export enum TestMutations {
  RESET = "RESET",
}
